import { FormType } from "./index";
export class TrackingObjectBuilder {
    forToggle({ id, toggleState }) {
        return {
            form_type: FormType.TOGGLE,
            form_id: id ? `toggle-${id}` : 'toggle',
            data: {
                toggleState,
            },
        };
    }
    forButtonClick({ clickText, clickUrl, parentComponent }) {
        return {
            event: 'button',
            eventType: 'click',
            clickText,
            ...(clickUrl && { clickUrl }),
            parentComponent,
        };
    }
    forLinkClick({ clickText, clickUrl, parentComponent }) {
        return {
            event: 'link',
            eventType: 'click',
            clickText,
            ...(clickUrl && { clickUrl }),
            parentComponent,
        };
    }
    forCheckboxOrToggleClick({ formName, fieldName, fieldValue, parentComponent, }) {
        return {
            event: 'form',
            eventType: 'submit',
            formName,
            fieldName,
            fieldValue,
            parentComponent,
        };
    }
    forQuestionaire({ question, answer, step, parentComponent, }) {
        return {
            event: 'questionnaire',
            eventType: 'answer',
            question,
            answer,
            step,
            parentComponent,
        };
    }
}
//# sourceMappingURL=tracking-object-builder.js.map
